import React from "react";
import { Link } from "react-router-dom";
import { FaHome, FaEnvelope } from "react-icons/fa";
import { MdCall } from "react-icons/md";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXTwitter, faLinkedin, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import image from "../assests/LOGO_KRISTELLAR_WHITE.png";
import image1 from "../assests/kris_cyber__2_-removebg-preview.png";
import image2 from "../assests/LogoIndia_ochre+white_horizontal.png";
import image3 from "../assests/kris_cyber__1_-removebg-preview.png";
import ScrollTop from "./ScrollTop";

const Footer = () => {
  return (
    <footer className="bg-navBlue text-gray-300 py-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-2">
        <div className="flex flex-col items-center lg:flex-row justify-around ">
          {/* Company Info */}
          <div className="flex flex-col items-center md:items-center text-center md:text-left sm:w-[35%] pt-4">
            <h2 className="text-lg md:text-xl font-bold text-white font-thin font-nova-square">
              COMPANY ADDRESS
            </h2>
            <div className="space-y-2 mt-4">
              {/* Address */}
              <div className="flex items-center md:items-center space-x-4 justify-center md:justify-start">
                <FaHome className="hidden sm:block text-[#77b5f7] w-5 h-5" />
                <a
                  href="https://www.google.com/maps/place/Nexus+Esplanade/@20.2957479,85.8587136,15z/data=!3m1!5s0x3a190a04febf96e9:0xbb3ed6b8c36a2487!4m6!3m5!1s0x3a190a05023c6bc5:0x57eb03e43d3dd622!8m2!3d20.291464!4d85.8560129!16s%2Fg%2F11ghsd2cxq?entry=ttu&g_ep=EgoyMDI1MDEyOS4xIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm md:text-base"
                >
                  OU - 403/404, Esplanade One, <br className="hidden md:block" /> Bhubaneswar 751010
                </a>
              </div>
              
              {/* Phone */}
              <div className="flex items-center md:items-start space-x-4 justify-center md:justify-start">
                <MdCall className="hidden sm:block text-[#77b5f7] w-5 h-5" />
                <a href="tel:06742915135" className="text-sm md:text-base">
                  +91 674 291 5135
                </a>
              </div>
              
              {/* Email */}
              <div className="flex items-center md:items-start space-x-4 justify-center md:justify-start">
                <FaEnvelope className="hidden sm:block text-[#77b5f7] w-5 h-5" />
                <a href="mailto:support@Kristellar.com" className="text-sm md:text-base">
                  support@kristellar.com
                </a>
              </div>
            </div>
            
            {/* Social Media Links */}
            <div className="flex space-x-4 mt-4 2xl:hidden lg:hidden">
              <a 
                href="https://www.youtube.com/@KristellarAerospace" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-300 hover:text-white"
              >
                <FontAwesomeIcon icon={faYoutube} className="w-5 h-5" />
              </a>
              <a 
                href="https://x.com/Kristellar9610" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-300 hover:text-white"
              >
                <FontAwesomeIcon icon={faXTwitter} className="w-5 h-5" />
              </a>
              <a 
                href="https://www.linkedin.com/in/kristellar-aerospace" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-300 hover:text-white"
              >
                <FontAwesomeIcon icon={faLinkedin} className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-gray-300 hover:text-white"
              >
                <FontAwesomeIcon icon={faInstagram} className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="hidden md:flex flex-col items-center md:items-item text-center md:text-left w-[35%] pt-4 md:mb-8">
            <h2 className="text-lg md:text-xl font-bold text-white font-nova-square font-thin pr-10 ">NAVIGATION</h2>
            <div className="flex flex-cols-2 gap-20 pt-3 ">
              <ul className="space-y-2 ">
                <li><Link to="/" className="hover:text-white text-sm md:text-base">Home</Link></li>
                <li><Link to="/products" className="hover:text-white text-sm md:text-base">Products</Link></li>
                <li><Link to="/project" className="hover:text-white text-sm md:text-base">Project</Link></li>
              </ul>
              <ul className="space-y-2">
                <li><Link to="/blog" className="hover:text-white text-sm md:text-base">Blog</Link></li>
                <li><Link to="/publication" className="hover:text-white text-sm md:text-base">Publication</Link></li>
                <li><Link to="/contact" className="hover:text-white text-sm md:text-base">Contact</Link></li>
              </ul>
            </div>
          </div>
          
          {/* Group Company */}
          <div className="flex flex-col items-center md:items-center text-center md:text-left md:w-[40%] pt-4 md:mb-6">
            <h2 className="text-lg md:text-xl font-bold text-white font-thin font-nova-square">GROUP COMPANIES</h2>
            <div className="flex flex-row justify-center md:justify-start items-center gap-4 mt-6">
              <a href="https://student.kristellar.com/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                <img src={image1} alt="Company 1" className="h-[60px] w-[900px] md:h-[70px] md:w-60 " />
              </a>
              <a href="https://www.protelion.ind.in/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                <img src={image2} alt="Company 2" className="h-[full] w-full md:h-14 md:w-[330px]" />
              </a>
              <a href="https://www.kristellarcyberspace.in/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">
                <img src={image3} alt="Company 3" className="h-[60px] w-[900px] md:h-[65px] md:w-60" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-2 pt-2 border-t border-gray-700 text-center text-sm">
          <p className="text-xs md:text-sm">© Kristellar Aerospace. All rights reserved.</p>
        </div>

        <ScrollTop />
      </div>
    </footer>
  );
};

export default Footer;